module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/brand/brand-list/brand-list.component.scss
// module id = ./src/app/brand/brand-list/brand-list.component.scss
// module chunks = main